import(/* webpackMode: "eager" */ "/my-first-project/components/site-header.tsx")